import { useQuery } from 'react-query';

import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';

import AuthorizationService from '@/api/Authorization/AuthorizationService';

import { useAppContext } from '../../App.context';

export const GET_ONE_TIME_TOKEN_QUERY = 'getOneTimeTokenQuery';

interface UseGetOneTimeTokenQueryArgs {
  invitationId?: string;
  invitationToken?: string;
}

export const useGetOneTimeTokenQuery = ({
  invitationId,
  invitationToken,
}: UseGetOneTimeTokenQueryArgs) => {
  const { pushErrors } = useToasts();
  const { login } = useAppContext();

  const { isLoading, data: token } = useQuery(
    [GET_ONE_TIME_TOKEN_QUERY, invitationId, invitationToken],
    async () => {
      if (!invitationId || !invitationToken) {
        return;
      }

      const response = await AuthorizationService.getOneTimeTokenQuery({
        invitationId,
        invitationToken,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return;
      }

      login({
        returnTo: '/',
        extraQueryParams: {
          login_hint: response.value.invitationEmail,
          one_time_token: response.value.oneTimeToken,
        },
      });

      return response.value;
    },
    {
      suspense: true,
      staleTime: 1_000,
    },
  );

  return {
    isLoading,
    token,
  };
};
